import { NgFor, AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatNavList,
  MatListItem,
  MatListItemAvatar,
  MatListItemTitle,
  MatListItemLine,
  MatListItemMeta,
} from '@angular/material/list';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe, AgrDatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { getObservationSwitchSetting } from '../../../settings/store/selectors/setting.selector';
import { Cycle } from '../../models/cycle.model';
import { getCycles } from '../../store/selectors/cycle.selectors';

@Component({
  selector: 'app-cycle-overview-simple',
  templateUrl: 'cycle-overview-simple.component.html',
  styleUrls: ['cycle-overview-simple.component.scss'],
  imports: [
    MatNavList,
    NgFor,
    MatListItem,
    RouterLink,
    MatIcon,
    MatListItemAvatar,
    MatListItemTitle,
    MatListItemLine,
    MatListItemMeta,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    AsyncPipe,
    TitleCasePipe,
    TranslatePipe,
    AgrDatePipe,
  ],
})
export class CycleOverviewSimpleComponent {
  private readonly store = inject<Store<RootState>>(Store);

  @Output() deleteClicked: EventEmitter<Cycle> = new EventEmitter<Cycle>();

  cycles$: Observable<Cycle[]> = this.store.select(getCycles);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  openMenu(event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  delete(cycle: Cycle) {
    this.deleteClicked.emit(cycle);
  }

  shouldShowWeekRegistrations(): Observable<boolean> {
    return this.store.select(getObservationSwitchSetting).pipe(take(1));
  }

  isWeekRegistrationsEnabled(cycle: Cycle): boolean {
    return !cycle.cycleDate || cycle.dayOldChicks.length === 0;
  }
}
